__turbopack_context__.v({
  "NewsCard": "R_l1LW_NewsCard",
  "NewsCard--1": "R_l1LW_NewsCard--1",
  "NewsCard--2": "R_l1LW_NewsCard--2",
  "NewsCard--3": "R_l1LW_NewsCard--3",
  "NewsCard__Arrow": "R_l1LW_NewsCard__Arrow",
  "NewsCard__Content": "R_l1LW_NewsCard__Content",
  "NewsCard__Date": "R_l1LW_NewsCard__Date",
  "NewsCard__ImageWrap": "R_l1LW_NewsCard__ImageWrap",
  "NewsCard__Preamble": "R_l1LW_NewsCard__Preamble",
  "NewsCard__Title": "R_l1LW_NewsCard__Title",
  "NewsCard__Top": "R_l1LW_NewsCard__Top",
});
